var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFavoritesEnabled
    ? _c(
        "viewer-layer",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.layerVisible,
              expression: "layerVisible",
            },
          ],
          staticClass: "bounce-in",
          class: { "bounce-in-active": _vm.favorites.dialog.visible },
          attrs: {
            "close-event": () => _vm.showFavoritesDialog(false),
            "inner-class-name": "viewer-layer-second-inner fullscreen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "favorites h-100" },
            [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("favorites.title")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tabs" },
                  _vm._l(_vm.tabs, function (tab) {
                    return _c(
                      "div",
                      {
                        key: tab.key,
                        staticClass: "tab",
                        class: { active: tab.key === _vm.activeTab },
                        on: {
                          click: function ($event) {
                            _vm.activeTab = tab.key
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(tab.label) + "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search" },
                  [
                    _c("el-input", {
                      attrs: {
                        "prefix-icon": "el-icon-search",
                        size: "medium",
                        clearable: "",
                      },
                      on: { input: _vm.getSortedData },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function ($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "export" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-download",
                          size: "medium",
                          loading: _vm.pdf.loading,
                        },
                        on: { click: _vm.exportPdf },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.pdf.active
                                ? _vm.$t("favorites.pdf.exporting")
                                : _vm.$t("favorites.pdf.export")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.favorites.inited
                ? [
                    _c("div", { staticClass: "list" }, [
                      _c("table", [
                        _c("thead", [
                          _c(
                            "tr",
                            _vm._l(_vm.columns, function (column) {
                              return _c(
                                "th",
                                {
                                  key: column.key,
                                  class: { clickable: column.sort !== false },
                                  attrs: { width: column.width },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortBy(column)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(column.text) +
                                      "\n                "
                                  ),
                                  column.sort !== false
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "sorting",
                                          class: {
                                            active: _vm.activeSort(column.key),
                                            asc:
                                              _vm.activeSort(column.key) &&
                                              _vm.isSortAsc(),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "isif isif-arrow-down",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm.sortedFavoriteData.length
                              ? [
                                  _vm._l(
                                    _vm.sortedFavoriteData,
                                    function (favorite) {
                                      return [
                                        _c(
                                          "tr",
                                          { key: "main-" + favorite.id },
                                          _vm._l(
                                            _vm.columns,
                                            function (column) {
                                              return _c(
                                                "td",
                                                {
                                                  key: column.key,
                                                  class: {
                                                    center: column.center,
                                                  },
                                                  style: {
                                                    width: column.width,
                                                  },
                                                },
                                                [
                                                  column.key === "image"
                                                    ? [
                                                        _vm.activeTab ===
                                                        "company"
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "item-image-link",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.activeSubRow =
                                                                        _vm.activeSubRow ===
                                                                        favorite.id
                                                                          ? ""
                                                                          : favorite.id
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                favorite.image
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "item-image",
                                                                      attrs: {
                                                                        src: favorite.image,
                                                                      },
                                                                    })
                                                                  : _c(
                                                                      "default-logo",
                                                                      {
                                                                        staticClass:
                                                                          "item-image",
                                                                      }
                                                                    ),
                                                              ],
                                                              1
                                                            )
                                                          : favorite.image
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "item-image-link",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.goto(
                                                                        favorite
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "item-image",
                                                                  attrs: {
                                                                    src: favorite.image,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    : column.key === "remove"
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "item-remove",
                                                            attrs: {
                                                              title:
                                                                _vm.$t(
                                                                  "favorites.remove"
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeFavorite(
                                                                  favorite
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "isif isif-trash",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    : column.key === "note"
                                                    ? [
                                                        _c("note", {
                                                          attrs: {
                                                            favorite: favorite,
                                                          },
                                                          on: {
                                                            update:
                                                              _vm.updateFavorite,
                                                          },
                                                        }),
                                                      ]
                                                    : [
                                                        _c("i-text-collapse", {
                                                          attrs: {
                                                            text:
                                                              favorite[
                                                                column.key
                                                              ] || "-",
                                                          },
                                                        }),
                                                      ],
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _vm.activeTab === "company"
                                          ? _c(
                                              "tr",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.activeSubRow ===
                                                      favorite.id,
                                                    expression:
                                                      "activeSubRow === favorite.id",
                                                  },
                                                ],
                                                key: "sub-" + favorite.id,
                                                staticClass: "sub-row",
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan:
                                                        _vm.columns.length,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "panoramas",
                                                      },
                                                      _vm._l(
                                                        favorite.panoramas,
                                                        function (panorama) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: panorama.id,
                                                              staticClass:
                                                                "panorama",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goto(
                                                                      panorama
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "thumb",
                                                                style: {
                                                                  backgroundImage: `url('${panorama.image}')`,
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "name",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        panorama.name
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    }
                                  ),
                                ]
                              : [
                                  _c("tr", { staticClass: "empty" }, [
                                    _c(
                                      "td",
                                      {
                                        attrs: { colspan: _vm.columns.length },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "favorites.table.listEmpty"
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]
                : [
                    _c("div", { staticClass: "loading" }, [
                      _c("img", {
                        attrs: { src: require("@/assets/images/loading.svg") },
                      }),
                    ]),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm.pdf.active
            ? _c("pdf", {
                attrs: {
                  "active-tab": _vm.activeTab,
                  category: _vm.category,
                  data: _vm.favoriteData,
                },
                on: { export: _vm.pdfExported },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }